class FreeShippingMeter extends HTMLElement {
    constructor() {
        super();

        this.freeShippingEligible = 0;
        this.cart = null;
    }

    connectedCallback() {
        this.progressBar = this.querySelector('[data-shipping-progress]');
        this.messageElement = this.querySelector('[data-shipping-message]');
        this.progressMeter = this.querySelector('[data-free-shipping-progress-meter]');

        if (!this.progressBar || !this.messageElement || !this.progressMeter) {
            console.warn('Free Shipping Meter: required elements are missing.');
            return;
        }

        this.textEnabled = this.progressBar.dataset.textEnabled === 'true';

        this.shippingText = window.free_shipping_text || {};

        this.freeShippingText =
            this.shippingText.free_shipping_message || '';

        this.freeShippingText1 =
            this.shippingText.free_shipping_message_1 || '';

        this.freeShippingText2 =
            this.shippingText.free_shipping_message_2 || '';

        this.freeShippingText3 =
            this.shippingText.free_shipping_message_3 || '';

        this.freeShippingText4 =
            this.shippingText.free_shipping_message_4 || '';

        this.shipVal =
            this.shippingText.free_shipping_1 || '';

        this.freeshipPrice = parseFloat(window.free_shipping_price) || 0;

        this.addEventListener(
            'change',
            this.onCartChange.bind(this)
        );

        this.initialize();
    }

    initialize() {
        if (
            typeof Shopify === 'undefined' ||
            typeof Shopify.getCart !== 'function'
        ) {
            console.warn('Free Shipping Meter: Shopify.getCart is unavailable.');
            return;
        }

        Shopify.getCart((cart) => {
            this.cart = cart;
            this.calculateProgress(cart);
        });
    }

    onCartChange() {
        this.initialize();
    }

    calculateProgress(cart) {
        if (!cart || this.freeshipPrice <= 0) {
            return;
        }

        let totalPrice = Number(cart.total_price) || 0;

        if (
            typeof window.jQuery !== 'undefined' &&
            $('body').hasClass('setup_shipping_delivery')
        ) {
            const giftCardItems = $(
                '.cart-item[data-price-gift-card], .previewCartItem[data-price-gift-card]'
            );

            if (giftCardItems.length > 0) {
                giftCardItems.each(function () {
                    const giftCardPrice = parseFloat(
                        $(this).attr('data-price-gift-card')
                    );

                    if (!isNaN(giftCardPrice)) {
                        totalPrice -= giftCardPrice;
                    }
                });
            }
        }

        const cartTotalPrice = totalPrice / 100;
        const cartTotalPriceRounded = Number(
            cartTotalPrice.toFixed(2)
        );

        let freeShipBar =
            (cartTotalPriceRounded * 100) / this.freeshipPrice;

        freeShipBar = Math.max(0, Math.min(100, freeShipBar));

        const text = this.getText(
            cartTotalPriceRounded,
            freeShipBar
        );

        const classLabel = this.getClassLabel(freeShipBar);

        this.setProgressWidthAndText(
            freeShipBar,
            text,
            classLabel
        );
    }

    getText(cartTotalPrice, freeShipBar) {
        let text = '';

        if (cartTotalPrice === 0) {
            this.progressBar.classList.add('progress-hidden');

            text =
                '<span>' +
                this.freeShippingText +
                ' ' +
                this.formatMoney(this.freeshipPrice * 100) +
                '!</span>';
        } else if (cartTotalPrice >= this.freeshipPrice) {
            this.progressBar.classList.remove('progress-hidden');

            this.freeShippingEligible = 1;

            text = this.freeShippingText1;
        } else {
            this.progressBar.classList.remove('progress-hidden');

            const remainingPrice =
                this.freeshipPrice - cartTotalPrice;

            text =
                '<span>' +
                this.freeShippingText2 +
                ' </span>' +
                this.formatMoney(remainingPrice * 100) +
                '<span> ' +
                this.freeShippingText3 +
                ' </span>' +
                '<span class="text">' +
                this.freeShippingText4 +
                '</span>';

            this.shipVal =
                this.shippingText.free_shipping_2 || '';
        }

        return text;
    }

    getClassLabel(freeShipBar) {
        if (freeShipBar === 0) {
            return 'none';
        }

        if (freeShipBar <= 30) {
            return 'progress-30';
        }

        if (freeShipBar <= 60) {
            return 'progress-60';
        }

        if (freeShipBar < 100) {
            return 'progress-100';
        }

        return 'progress-free';
    }

    resetProgressClass(classLabel) {
        this.progressBar.classList.remove(
            'none',
            'progress-30',
            'progress-60',
            'progress-100',
            'progress-free'
        );

        if (classLabel) {
            this.progressBar.classList.add(classLabel);
        }
    }

    setProgressWidthAndText(
        freeShipBar,
        text,
        classLabel
    ) {
        setTimeout(() => {
            if (
                !this.progressBar ||
                !this.progressMeter ||
                !this.messageElement
            ) {
                return;
            }

            this.resetProgressClass(classLabel);

            this.progressMeter.style.width =
                `${freeShipBar}%`;

            if (this.textEnabled) {
                const progressText =
                    this.progressMeter.querySelector('.text');

                if (progressText) {
                    progressText.innerHTML =
                        `${freeShipBar.toFixed(2)}%`;
                }
            }

            this.messageElement.innerHTML = text;

            if (
                typeof Currency !== 'undefined' &&
                (
                    (
                        window.show_multiple_currencies &&
                        typeof shopCurrency !== 'undefined' &&
                        Currency.currentCurrency !== shopCurrency
                    ) ||
                    window.show_auto_currency
                )
            ) {
                const currency =
                    $('#currencies .active')
                        .attr('data-currency');

                if (currency) {
                    Currency.convertAll(
                        window.shop_currency,
                        currency,
                        'span.money',
                        'money_format'
                    );
                }
            }
        }, 400);
    }

    formatMoney(amount) {
        if (
            typeof Shopify !== 'undefined' &&
            typeof Shopify.formatMoney === 'function'
        ) {
            return Shopify.formatMoney(
                Math.round(amount),
                window.money_format
            );
        }

        return (
            '$' +
            (amount / 100).toFixed(2)
        );
    }
}

if (!customElements.get('free-shipping-component')) {
    customElements.define(
        'free-shipping-component',
        FreeShippingMeter
    );
}